
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { updateDriverSeeker } from "../../../features/ilanlar/ilanlarSlice"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import InputNumberWithSuffix from "../../shared/input/new/InputNumberWithSuffix"
import locationCityList from "../../../utils/locationData/locationCityOptions"
import InputSelectCityMultiple from "../../shared/input/new/InputSelectCityMulti"
import InputNumberNew from "../../shared/input/new/InputNumberNew"
import InputDate from "../../shared/input/new/InputDate"
import InputTextarea from "../../shared/input/new/InputTextarea"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        overflow: auto;
        position: relative;
        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inputs{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 70%;
                margin-top: 30px;
                padding-inline: 30px;
                .row{
                    width: 100%;
                }
            }

            .btn-group{
                display: flex;
                align-items: center;
                margin-block: 20px;
                position: sticky;
                bottom: 0;
                justify-content: center;
                background-color: white;
                gap: 15px;
                width: 100%;
                height: 60px;
            }
        }
        
    }

`

const advertData = [
    {
        id:1,
        text:"Yayında"
    },
    {
        id:2,
        text:"Arşivde"
    }
]
    
const DriverSeekerUpdateModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectedAdvert } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    const [contactPhone, setContactPhone] = useState(selectedAdvert?.contactNumber)
    const [cityList, setCityList] = useState(selectedAdvert?.driverSeekerWorkCities?.$values?.map(city => {
        return locationCityList.find(location => location.city === city.city);
    }))
    const [advertStatus, setAdvertStatus] = useState(advertData?.find(item => item.text === selectedAdvert?.advertStatus))

    const [data, setData] = useState({
        numberOfDrivers: selectedAdvert?.driverCount,
        salary: selectedAdvert?.salary,
        benefits: selectedAdvert?.otherBenefits,
        weekHolidays: selectedAdvert?.weekHoliday,
        description: selectedAdvert.description,
        advertEndDate: selectedAdvert?.advertEndDate.split("T")[0],
        title: selectedAdvert.title
    })

    useEffect(() => {
        if (contactPhone) {
            const formattedPhoneNumber = (contactPhone.startsWith("+90") || contactPhone.startsWith("90")) ? `${contactPhone}` : `90${contactPhone}`;
            setContactPhone(formattedPhoneNumber);
        }
    }, []);

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const stringToNum = (item) => {
        const numericString = item.replace(/\D/g, "");
        const intValue = parseInt(numericString);
        return intValue
    }
    
    const handleSubmit = () => {
        const addData = {
            id: selectedAdvert?.id,
            contactNumber: contactPhone?.slice(2),
            driverCount: parseInt(data?.numberOfDrivers),
            salary: (typeof data?.salary === "string") ? stringToNum(data?.salary) : data?.salary,
            otherBenefits: data?.benefits,
            weekHoliday: data?.weekHolidays,
            driverSeekerWorkCities: cityList?.map((item) => {
                const findCities = selectedAdvert?.driverSeekerWorkCities?.$values?.find(innerItem => innerItem?.cityId === parseInt(item?.cityId))
                if(findCities){
                    return {...item, id: findCities?.id}
                }else{
                    return {...item, id: 0}
                }
            }),
            advertEndDate: data?.advertEndDate,
            description: data?.description,
            title: data.title
        }
        dispatch(updateDriverSeeker(addData))
    }

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }
   
  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Sürücü İlanı"}/>

            <div className="content">
                <div className="inputs">
                    <div className="row">
                        <InputText data={data?.title} name={"title"} setData={(e) => handleChange(e)} labelText={"İlan Başlığı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputPhoneFormat data={contactPhone} setData={setContactPhone} name={"contactPhone"} labelText={"Aranacak Telefon No"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputSelectCityMultiple data={cityList} setData={setCityList} labelText={"Çalışacak İl / İller"} initialOptions={locationCityList} inputWidth={"100%"} name={"iller"}/>
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix noneSeperator data={data?.numberOfDrivers} name={"numberOfDrivers"} setData={(e) => handleChange(e)} labelText={"Alınacak Sürücü Sayısı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" TL"} data={data?.salary} name={"salary"} setData={(e) => handleChange(e)} labelText={"Maaş"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberNew data={data?.benefits} name={"benefits"} setData={(e) => handleChange(e)} labelText={"Diğer Yan Haklar"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={data?.weekHolidays} name={"weekHolidays"} setData={(e) => handleChange(e)} labelText={"Hafta Tatili"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputTextarea data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText={"Açıklama"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputDate data={data?.advertEndDate} setData={(e) => handleChange(e)} labelText={"İlan Bitiş Tarihi"} name={"advertEndDate"} inputWidth={"100%"} />
                    </div>
                    
                </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Güncelle</Button>
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default DriverSeekerUpdateModal